import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AppHeader } from "../components/AppHeader";
import { AppSidebar } from "../components/AppSidebar";
import { getCoMemberMe, ApiError } from "../services/api";
import { useAuth } from "../services/auth-context";

/** Guards every /co-member/* route. Checks GET /co/co-members/me on mount so a page refresh
 * (not just a fresh login) correctly recognizes an existing, still-valid session cookie. */
export function CoMemberLayout() {
  const { auth, setAuth } = useAuth();
  const [checked, setChecked] = useState(auth?.role === "co_member");

  useEffect(() => {
    if (auth?.role === "co_member") {
      setChecked(true);
      return;
    }
    getCoMemberMe()
      .then(() => {
        setAuth({ role: "co_member" });
        setChecked(true);
      })
      .catch((err) => {
        if (!(err instanceof ApiError)) throw err;
        setChecked(true); // not logged in — render() below redirects to login
      });
    // Only re-check when the auth context itself hasn't already confirmed co_member.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!checked) return null; // avoid a login-page flash while the check is in flight
  if (auth?.role !== "co_member") return <Navigate to="/co-member/login" replace />;

  return (
    <div className="flex h-full flex-col">
      <AppHeader />
      <div className="flex flex-1 overflow-hidden">
        <AppSidebar role="co_member" />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
